<div class="" [ngClass]="onFocusClasses">
  <div class="form-group mb-0" [ngClass]="{ 'form-group': !formGroupToggle }">
    <label [hidden]="simpleView == true" class="w-100" (click)="onlabelClick()" [title]="appcode">
      {{ selectizeOptions.placholderKey | translate }}
    </label>
    <div class="flex-container">
      <div class="selectize-control demo-default single" style="flex-grow: 8">
        <div class="input-group input-group-sm" [ngClass]="{ newin: multiItems.length > 0 }">
          <div>
            <div *ngFor="let item of multiItems">
              <span *ngIf="translate.currentLang == 'ar'" (click)="select(item)">
                {{ item["customCode"] ? item["customCode"] : item["code"] }}-{{
                item[selectizeOptions.labelFieldAr]
                }}
                <!-- <span class="birch_close_btn" (click)="select(item)">x </span> dont need it much more -->
              </span>
              <span *ngIf="translate.currentLang == 'en'" (click)="select(item)">
                {{ item["customCode"] ? item["customCode"] : item["code"] }}-{{
                item[selectizeOptions.labelField]
                }}
                <!-- <span class="birch_close_btn" (click)="select(item)">x </span> -->
              </span>
            </div>
          </div>
          <!-- [value]="selectizeOptions.currentResults[0].code" -->
          <div class="new-in-input-container" [ngClass]="radiusSize > 0 ? 'add-radius' : 'no-radius'"
            [style.background-color]="inputBackgroundColor" [title]="parentSerial||appcode">
            <input type="text" #inputElement [attr.disabled]="_disabled" [attr.required]="required" [hidden]="canceled"
              class="form-control w-100" placeholder="{{ selectizeOptions.placholderKey | translate }}"
              [formControl]="searchInputControl" (keyup)="onEnter(inputElement.value)" (blur)="onInputBlur()"
              (change)="onChange($event)" (dblclick)="eventEmitDoubleClick($event)" (focus)="onFocus(value)"
              (keydown)="onInputKeyDown($event)" (keyup.enter)="showAddMulti?emitSelectedItems():''"
              [tabindex]="tabindex" [style.height]="inputHeight" [ngStyle]="cssStyles" [style.color]="textColor"
              [style.borderColor]="borderColor" [style.border]="borderstyle" [ngClass]="{
                'add-radius': radiusSize > 0,
                'rounded-custom': noRadius == 0,
                'delete-outline': outlineSize == 0
              }" />
            <!-- [style.color]="cancelColor" -->

            <i class="fa fa-times-circle" *ngIf="_disabled != true && selectizeOptions?.selected && !multi"
              placement="top" ngbTooltip="press to remove selected" (click)="clear(false)">
            </i>
            <i class="fa fa-angle-up" *ngIf="_disabled != true && toggleDropdown" placement="top" (click)="onBlur()">
            </i>

            <i class="fa fa-plus" *ngIf="multiItems?.length > 0 && showAddMulti" style="margin-left: 15px"
              placement="top" ngbTooltip="Add Selected Items" (click)="emitSelectedItems()"></i>
            <i class="fa fa-trash text-danger" [ngStyle]="{'margin-left': showAddMulti?'36px':'15px'}" *ngIf="
                multiItems?.length > 0 && !multiItems[0]['highLightedForMulti']
              " placement="top" ngbTooltip="delete Selected Items" (click)="deleteMltiItems()"></i>
          </div>

          <span [hidden]="!canceled">
            {{ searchInputControl.value }}
          </span>
        </div>
      </div>
      <icon-action *ngIf="isActionIconVisiable" (clicked)="rowIconClickTwo($event, 'row')"
        [appCodes]="actionsSettingsList" [selectizeOptionsView]="defaultSelectedAppCodes"></icon-action>
    </div>
  </div>

  <div class="selectize-dropdown single demo-default"
    [ngClass]="{ fadeInDown: toggleDropdown, fadeOut: !toggleDropdown }" *ngIf="toggleDropdown">
    <div #scroll class="selectize-dropdown-content list-group"
      style="min-width: 250px; max-height: 300px; overflow-y: auto;">
      <div *ngFor="let item of selectizeOptions.currentResults;let i = index;" #optionElements
        class="option list-group-item" [ngClass]="{'selected': i == highLightedOptionInedx, highLightedOption:
        highLightedOption == item[selectizeOptions.valueField] ||
        item.highLightedForMulti,
      highLightedForMulti: item.highLightedForMulti
        }" [attr.data-value]="item[selectizeOptions.valueField]" (click)="select(item);onOptionClick(i);"
        [attr.aria-selected]="i == highLightedOptionInedx" [attr.tabindex]="i == highLightedOptionInedx ? 0 : -1"
        (mouseover)="onMouseHover(item)">
        <div class="row" [ngSwitch]="appcode">
          <!-- selectize template area -->
          <ng-template [ngSwitchCase]="'1052'">
            <div *ngIf="item['customCode'] != null">
              <span class="col-sm-10" *ngIf="translate.currentLang == 'ar'">{{ item["customCode"] }}-
                {{ item[selectizeOptions.labelFieldAr] }}</span>
              <span class="col-sm-10" *ngIf="translate.currentLang == 'en'">{{ item["customCode"] }}-
                {{ item[selectizeOptions.labelField] }}</span>
            </div>
            <div *ngIf="item['customCode'] == null">
              <span class="col-sm-10" *ngIf="translate.currentLang == 'ar'">{{ item["code"] }}-
                {{ item[selectizeOptions.labelFieldAr] }}</span>
              <span class="col-sm-10" *ngIf="translate.currentLang == 'en'">{{ item["code"] }}-
                {{ item[selectizeOptions.labelField] }}</span>
            </div>
            <span class="col" title="{{item.apologizeReason}}" *ngIf="item.apologizeFlag == 1">
              <i class="fa fa-danger fa-info-circle"></i>
            </span>
          </ng-template>
          <!-- abdo -->
          <ng-template [ngSwitchCase]="'1247'">
            <div *ngIf="item['customCode'] != null">
              <span class="col-sm-10" *ngIf="translate.currentLang == 'ar'">{{ item["customCode"] }}-
                {{ item[selectizeOptions.labelFieldAr]
                }}<span *ngIf="item['genericName'] && linkId == 5368" style="color: red; font-size: 12px">({{
                  item["genericName"] }})</span></span>
              <span class="col-sm-10" *ngIf="translate.currentLang == 'en'">{{ item["customCode"] }}- {{
                item[selectizeOptions.labelField]
                }}<span *ngIf="item['genericName'] && linkId == 5368" style="color: red; font-size: 12px">({{
                  item["genericName"] }})</span></span>
            </div>
            <div *ngIf="item['customCode'] == null">
              <span class="col-sm-10" *ngIf="translate.currentLang == 'ar'">{{ item["code"] }}- {{
                item[selectizeOptions.labelFieldAr]
                }}<span *ngIf="item['genericName'] && linkId == 5368" style="color: red; font-size: 12px">({{
                  item["genericName"] }})</span></span>
              <span class="col-sm-10" *ngIf="translate.currentLang == 'en'">{{ item["code"] }}- {{
                item[selectizeOptions.labelField]
                }}<span *ngIf="item['genericName'] && linkId == 5368" style="color: red; font-size: 12px">({{
                  item["genericName"] }})</span></span>
            </div>
            <span class="col" *ngIf="item.apologizeFlag == 1">
              <i class="fa fa-danger fa-info-circle"></i>
            </span>
          </ng-template>
          <ng-template [ngSwitchCase]="'1109'">
            <div *ngIf="item['customCode'] != null">
              <span class="col-sm-10" *ngIf="translate.currentLang == 'ar'">{{ item["customCode"] }}-
                {{ item[selectizeOptions.labelFieldAr] }}</span>
              <span class="col-sm-10" *ngIf="translate.currentLang == 'en'">{{ item["customCode"] }}-
                {{ item[selectizeOptions.labelField] }}</span>
            </div>
            <div *ngIf="item['customCode'] == null">
              <span class="col-sm-10" *ngIf="translate.currentLang == 'ar'">{{ item["code"] }}-
                {{ item[selectizeOptions.labelFieldAr] }}</span>
              <span class="col-sm-10" *ngIf="translate.currentLang == 'en'">{{ item["code"] }}-
                {{ item[selectizeOptions.labelField] }}</span>
            </div>
            <span class="col" *ngIf="item.apologizeFlag == 1">
              <i class="fa fa-danger fa-info-circle"></i>
            </span>
          </ng-template>
          <ng-template [ngSwitchCase]="'1040'">
            <span class="col-sm-10" *ngIf="translate.currentLang == 'ar'">{{ item["code"] }}-
              {{ item[selectizeOptions.labelFieldAr] }}</span>
            <span class="col-sm-10" *ngIf="translate.currentLang == 'en'">{{ item["code"] }}- {{
              item[selectizeOptions.labelField] }}</span>

            <span class="col text-danger" *ngIf="item.statusFlag == 0">
              {{ "InActive" | translate }}
            </span>

            <span class="col text-danger" *ngIf="item.expireFlag == 1">
              {{ "Expire" | translate }}
            </span>
          </ng-template>
          <!---------------ASMAA_For Doctors Vaction in DropDown------------------->
          <ng-template [ngSwitchCase]="'1014'">
            <span class="col-sm-10" *ngIf="translate.currentLang == 'ar'">{{ item["customCode"] ? item["customCode"] :
              item["code"] }}-
              {{ item[selectizeOptions.labelFieldAr] }}</span>
            <span class="col-sm-10" *ngIf="translate.currentLang == 'en'">{{ item["customCode"] ? item["customCode"] :
              item["code"] }}-
              {{ item[selectizeOptions.labelField] }}</span>

            <span class="col text-danger" *ngIf="item.hasVacation == 1">
              {{ "ONVACATION" | translate }}
            </span>
            <span class="col text-success" *ngIf="item.activeFlag == 1">
              ( {{ item["notes"]}} )
            </span>
          </ng-template>
          <!--------------------انا علياء عملتلها كومنت لانها بتخلي اسم الطبيب يتكرر مرتين------------------->

          <!---------------------------ASMAA_DR_ACTIVE_NOTES------------------------------------>
          <!-- <ng-template [ngSwitchCase]="1014">
            <span class="col-sm-10" *ngIf="translate.currentLang == 'ar'">{{ item["code"] }}-
              {{ item[selectizeOptions.labelFieldAr] }}</span>
            <span class="col-sm-10" *ngIf="translate.currentLang == 'en'">{{ item["code"] }}- {{
              item[selectizeOptions.labelField] }}</span>


            <span class="col text-success" *ngIf="item.activeFlag == 1">
              ( {{ item["notes"]}} )
            </span>
          </ng-template> -->

          <!---------------------------EDN OF ASMAA------------------------------>
          <!--gouhr to set in active secLogins-->
          <ng-template [ngSwitchCase]="'1077'">
            <span class="col-sm-10" *ngIf="translate.currentLang == 'ar'">{{ item["code"] }}-
              {{ item[selectizeOptions.labelFieldAr] }}</span>
            <span class="col-sm-10" *ngIf="translate.currentLang == 'en'">{{ item["code"] }}- {{
              item[selectizeOptions.labelField] }}</span>

            <span class="col text-danger" *ngIf="item.active == 0">
              {{ "InActive" | translate }}
            </span>

            <!--<span class="col-md-2 text-danger" *ngIf="item.active==1">
                {{ 'Expire' | translate }}
            </span>-->
          </ng-template>
          <ng-template [ngSwitchCase]="'1078'">
            <span class="col-sm-10" *ngIf="translate.currentLang == 'ar'">{{ item["code"] }}-
              {{ item[selectizeOptions.labelFieldAr] }}</span>
            <span class="col-sm-10" *ngIf="translate.currentLang == 'en'">{{ item["code"] }}-
              {{ item[selectizeOptions.labelField] }}
            </span>
            <span class="col text-danger" *ngIf="item.underInventory == 1">
              {{ "UNDERINVENTORY" | translate }}
            </span>
          </ng-template>
          <ng-template [ngSwitchCase]="'1044'">
            <span class="col-sm-10" *ngIf="translate.currentLang == 'ar'">{{ item["code"] }}-
              {{ item[selectizeOptions.labelFieldAr] }}
              <span *ngIf="item['genericName'] && linkId == 5226" style="color: red; font-size: 12px">({{
                item["genericName"] }})</span>
            </span>
            <span class="col-sm-10" *ngIf="translate.currentLang == 'en'">{{ item["code"] }}-
              {{ item[selectizeOptions.labelField] }}
              <span *ngIf="item['genericName'] && linkId == 5226" style="color: red; font-size: 12px">({{
                item["genericName"] }})</span>
            </span>
          </ng-template>
          <!--gouhr to set in active secLogins-->
          <ng-template [ngSwitchCase]="'1063'">
            <span class="col-sm-10" *ngIf="translate.currentLang == 'ar'">
              {{ item["code"] }}-{{ item[selectizeOptions.labelFieldAr] }}</span>
            <span class="col-sm-10" *ngIf="translate.currentLang == 'en'">{{ item["code"] }}- {{
              item[selectizeOptions.labelField] }}</span>
            <span class="col text-danger" *ngIf="item.active == 0">
              {{ "InActive" | translate }}
            </span>
          </ng-template>
          <ng-template [ngSwitchCase]="'51'">
            <span class="col" *ngIf="translate.currentLang == 'ar'">
              {{ item["code"] }}-{{ item[selectizeOptions.labelField] }}</span>
            <span class="col" *ngIf="translate.currentLang == 'en'">{{ item["code"] }}-{{
              item[selectizeOptions.labelField] }}</span>
          </ng-template>
          <ng-template [ngSwitchCase]="'1069'">
            <span *ngIf="translate.currentLang == 'ar'">
              {{ item[selectizeOptions.labelField] }}</span>
            <span *ngIf="translate.currentLang == 'en'">{{
              item[selectizeOptions.labelField]
              }}</span>
            <span *ngIf="item['code'] == null && addNewItem == 1">&nbsp;&nbsp; Would you like to add "{{ newItemValue
              }}" ?</span>
          </ng-template>
          <ng-template [ngSwitchCase]="'1492'">
            <span *ngIf="translate.currentLang == 'ar'" class="row">
              <strong style="color:#d62c16;"> ( {{ item["regPatServiceSerial"] }})</strong>
              <strong style="color:#868e96;"> كودالمريض:</strong>
              <p style="color:#d62c16;"> {{ item["patCode"] }} </p>
              <strong style="color:#868e96;"> اسم المريض:</strong>
              <p style="color:#1676d6;"> {{ item["fullnameAr"] }}</p>--
              <strong style="color:#868e96;"> اسم الخدمه:</strong>

              <p style="color:#d62c16;"> {{ item["serviceNameAr"] }}</p>--
              <p style="color:#1676d6;"> {{ item["contractAr"] }}</p> --
              <p style="color:#1676d6;"> {{ item["deviceNameAr"] }}</p>--
              <p style="color:#1676d6;"> {{ item["comingFromAr"] }}</p>--
              <p style="color:#868e96;;"> ملاحظات</p>--<p style="color:#1676d6;"> {{ item["notes"] }}</p>
              <p style="color:#868e96;"> الوقت</p>
              <p style="color:#1676d6;"> {{ item["slotTime"] }}</p>


            </span>
            <span *ngIf="translate.currentLang == 'en'"><strong style="color:#868e96;"> كودالمريض:</strong>
              <p style="color:#d62c16;"> {{ item["patCode"] }} </p>
              <strong style="color:#868e96;"> Patient Name:</strong>
              <p style="color:#1676d6;"> {{ item["fullnameEn"] }}</p>--
              <strong style="color:#868e96;"> Service Name:</strong>

              <p style="color:#d62c16;"> {{ item["serviceNameEn"] }}</p>--
              <p style="color:#1676d6;"> {{ item["contractEn"] }}</p> --
              <p style="color:#1676d6;"> {{ item["deviceNameEn"] }}</p>--
              <p style="color:#1676d6;"> {{ item["comingFromEn"] }}</p>--
              <p style="color:#868e96;;"> Notes</p>--<p style="color:#1676d6;"> {{ item["notes"] }}</p>
              <p style="color:#868e96;"> Time</p>
              <p style="color:#1676d6;"> {{ item["slotTime"] }}</p>
            </span>

          </ng-template>
          <ng-template [ngSwitchCase]="'1288'">
            <div *ngIf="item['customCode'] != null">
              <span *ngIf="translate.currentLang == 'ar'">{{ item["customCode"] }}-
                {{ item[selectizeOptions.labelFieldAr] }}</span>
              <span *ngIf="translate.currentLang == 'en'">{{ item["customCode"] }}-
                {{ item[selectizeOptions.labelField] }}</span>
            </div>
            <div *ngIf="item['customCode'] == null">
              <span *ngIf="translate.currentLang == 'ar'"> {{ item[selectizeOptions.labelFieldAr] }}</span>
              <span *ngIf="translate.currentLang == 'en'"> {{ item[selectizeOptions.labelField] }}</span>
            </div>
            <span *ngIf="item['code'] == null && addNewItem == 1">&nbsp;&nbsp; Would you like to add "{{ newItemValue
              }}"?</span>
            <span *ngIf="item['code'] == null && addNewItem == 2">&nbsp;&nbsp; Would you like to add "{{ newItemValue
              }}"?</span>
          </ng-template>
          <ng-template ngSwitchDefault>
            <div *ngIf="item['customCode'] != null">
              <span *ngIf="translate.currentLang == 'ar'">{{ item["customCode"] }}-
                {{ item[selectizeOptions.labelFieldAr] }}</span>
              <span *ngIf="translate.currentLang == 'en'">{{ item["customCode"] }}-
                {{ item[selectizeOptions.labelField] }}</span>
            </div>
            <div *ngIf="item['customCode'] == null">
              <span *ngIf="translate.currentLang == 'ar'">{{ item["code"] }}-
                {{ item[selectizeOptions.labelFieldAr] }}</span>
              <span *ngIf="translate.currentLang == 'en'">{{ item["code"] }}-
                {{ item[selectizeOptions.labelField] }}</span>
            </div>
            <span *ngIf="item['code'] == null && addNewItem == 1">&nbsp;&nbsp; Would you like to add "{{ newItemValue
              }}"?</span>
            <span *ngIf="item['code'] == null && addNewItem == 2">&nbsp;&nbsp; Would you like to add "{{ newItemValue
              }}"?</span>
          </ng-template>
        </div>
      </div>

      <!-- <p-paginator></p-paginator> -->

      <div id="_paginator" class="_paginator" [class]="styleClass" [ngStyle]="heightOfSelectize"
        style="border: 0 !important" [hidden]="!paginator" class="text-sm-center"
        [ngClass]="{ 'card-header py-0 px-0': true }">
        <span class="btn btn-sm" style="
            border-radius: 0 !important;
            font-weight: 700;
            padding: 0.3rem 0.5rem;
            font-size: 0.9rem;
            border-style: solid;
            border-width: 1px;
            border-color: blue;
          ">
          {{ _totalRecords }}
        </span>
        <!-- first page -->
        <a href="#" #nextlink class="btn btn-secondary btn-sm" style="
            border-radius: 0 !important;
            font-weight: 700;
            padding: 0.3rem 0.5rem;
            font-size: 0.9rem;
          " (mouseenter)="hoveredItem = $event.target" (mouseleave)="hoveredItem = null"
          (click)="changePageToFirst($event)" [ngClass]="{
            'ui-state-disabled': isLastPage(),
            'ui-state-hover': nextlink === hoveredItem && !isLastPage()
          }" [tabindex]="isLastPage() ? -1 : null">
          <span class="fa fa-forward"></span>
        </a>
        <!-- prev page -->
        <a href="#" #lastlink class="btn btn-secondary btn-sm" style="
            border-radius: 0 !important;
            font-weight: 700;
            padding: 0.3rem 0.5rem;
            font-size: 0.9rem;
          " (mouseenter)="hoveredItem = $event.target" (mouseleave)="hoveredItem = null"
          (click)="changePageToPrev($event)" [ngClass]="{
            'ui-state-disabled': isLastPage(),
            'ui-state-hover': lastlink === hoveredItem && !isLastPage()
          }" [tabindex]="isLastPage() ? -1 : null">
          <span class="fa fa-step-forward"></span>
        </a>
        <span class="ui-paginator-pages">
          <button href="#" #plink *ngFor="let pageLink of pageLinks" class="btn btn-secondary btn-sm" style="
              border-radius: 0 !important;
              font-weight: 700;
              padding: 0.43rem 0.5rem;
              font-size: 0.7rem;
            " (mouseenter)="hoveredItem = $event.target" (mouseleave)="hoveredItem = null"
            (click)="changePage(pageLink - 1, $event, 'specificPageNo')" [ngClass]="{
              'btn-warning': plink === hoveredItem,
              'btn-info': pageLink - 1 == getPage()
            }">
            {{ pageLink }}
          </button>
        </span>
        <!-- next -->
        <a href="#" #firstlink class="btn btn-secondary btn-sm" style="
            border-radius: 0 !important;
            font-weight: 700;
            padding: 0.3rem 0.5rem;
            font-size: 0.9rem;
          " (mouseenter)="hoveredItem = $event.target" (mouseleave)="hoveredItem = null"
          (click)="changePageToNext($event)" [ngClass]="{
            'ui-state-disabled': isFirstPage(),
            'ui-state-hover': firstlink === hoveredItem && !isFirstPage()
          }" [tabindex]="isFirstPage() ? -1 : null">
          <span class="fa fa-step-backward"></span>
        </a>
        <!-- last -->
        <a #prevlink class="btn btn-secondary btn-sm" style="
            border-radius: 0 !important;
            font-weight: 700;
            padding: 0.3rem 0.5rem;
            font-size: 0.9rem;
          " (mouseenter)="hoveredItem = $event.target" (mouseleave)="hoveredItem = null"
          (click)="changePageToLast($event)" [ngClass]="{
            'ui-state-disabled': isFirstPage(),
            'ui-state-hover': prevlink === hoveredItem && !isFirstPage()
          }" [tabindex]="isFirstPage() ? -1 : null">
          <span class="fa fa-backward"></span>
        </a>

        <select class="ui-paginator-rpp-options ui-widget ui-state-default position-relative"
          style="top: 2px; border: 1px #868e96 solid" *ngIf="rowsPerPageOptions" (change)="onRppChange($event)">
          <option (click)="$event.stopPropagation()" *ngFor="let opt of rowsPerPageOptions" [value]="opt"
            [selected]="rows == opt">
            {{ opt }}
          </option>
        </select>
        <a #prevlink class="btn btn-secondary btn-sm" style="
            border-radius: 0 !important;
            font-weight: 700;
            padding: 0.3rem 0.5rem;
            font-size: 0.9rem;
          " (mouseenter)="hoveredItem = $event.target" (mouseleave)="hoveredItem = null"
          (click)="refreshCurrent($event)" [ngClass]="{
            'ui-state-disabled': isFirstPage(),
            'ui-state-hover': prevlink === hoveredItem && !isFirstPage()
          }" [tabindex]="isFirstPage() ? -1 : null">
          <span class="fa fa-refresh"></span>
        </a>
      </div>

      <!-- end of paginator -->
      <!-- end of paginator -->
      <!-- end of paginator -->
      <!-- end of paginator -->
    </div>
  </div>
</div>